import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable camelcase */
import React from 'react';
import { ColorBatch, Button } from 'components';
import { dateFormat, REPORT_STATUS, reportStatusName, reportStatusColorMap } from 'enums';
import { convertToAdditionalCurrency, showApiError } from 'utils';
import { getReportDocument } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var handleViewDocument = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(reportId, documentType) {
    var _yield$getReportDocum, _yield$getReportDocum2, res, err, url;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getReportDocument(reportId, documentType);

          case 2:
            _yield$getReportDocum = _context.sent;
            _yield$getReportDocum2 = _slicedToArray(_yield$getReportDocum, 2);
            res = _yield$getReportDocum2[0];
            err = _yield$getReportDocum2[1];

            if (!err) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", showApiError(err));

          case 8:
            url = URL.createObjectURL(new File([res], 'document.pdf', {
              type: 'application/pdf'
            }));
            window.open(url, '_blank');

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleViewDocument(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var reportedPaymentsColumns = function reportedPaymentsColumns(userOfficeId, onConfirm) {
  return [{
    name: 'ИД',
    render: function render(_ref2) {
      var id = _ref2.id;
      return ___EmotionJSX("span", {
        "data-value": "report.id"
      }, id);
    },
    width: '80px'
  }, {
    name: 'Дата',
    value: 'created_at',
    dateTimeFormat: dateFormat,
    width: '120px'
  }, {
    name: 'Сума',
    render: function render(_ref3) {
      var total_amount = _ref3.total_amount,
          currency = _ref3.currency;
      return ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "report.total_amount"
      }, total_amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: total_amount,
        fromCurrency: currency
      })));
    }
  }, {
    name: 'Статус',
    render: function render(_ref4) {
      var status = _ref4.status;
      return ___EmotionJSX(ColorBatch, {
        type: reportStatusColorMap[status]
      }, reportStatusName[status]);
    },
    width: '150px'
  }, {
    name: 'Документи',
    render: function render(_ref5) {
      var id = _ref5.id,
          status = _ref5.status;
      return ___EmotionJSX("div", {
        style: {
          display: 'flex',
          gap: '0.5em',
          flexDirection: 'column'
        }
      }, (status === REPORT_STATUS.pending || status === REPORT_STATUS.confirmed) && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return handleViewDocument(id, 'payment_report_expenditure');
        }
      }, "\u0420\u041A\u041E"), status === REPORT_STATUS.confirmed && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return handleViewDocument(id, 'payment_report_income');
        }
      }, "\u041F\u041A\u041E"));
    },
    width: '100px'
  }, {
    name: 'Служител',
    render: function render(_ref6) {
      var user = _ref6.user;
      return ___EmotionJSX("span", {
        "data-value": "report.user"
      }, user === null || user === void 0 ? void 0 : user.name);
    },
    width: '140px',
    invisibleBelow: 1600
  }, {
    name: 'Офис',
    render: function render(_ref7) {
      var office = _ref7.office;
      return ___EmotionJSX("span", {
        "data-value": "report.office"
      }, office === null || office === void 0 ? void 0 : office.name);
    },
    width: '120px',
    invisibleBelow: 1600
  }, {
    name: 'Действия',
    render: function render(report) {
      if (userOfficeId !== report.office_id || report.status !== REPORT_STATUS.pending) return null;
      return ___EmotionJSX(Button, {
        small: true,
        type: "success",
        onClick: function onClick() {
          return onConfirm(report);
        }
      }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438");
    },
    width: '120px'
  }];
};